import { render, staticRenderFns } from "./AlertDismissible.vue?vue&type=template&id=d41ff3c8&"
import script from "./AlertDismissible.vue?vue&type=script&lang=js&"
export * from "./AlertDismissible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAlert,VBtn,VListItemSubtitle})
